import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IResponse } from 'src/app/pages/base/interfaces';
import { MaestroModel } from '../maestro.model';
import { ContactoService } from 'src/app/services/notificacion/contacto.service';


export class Contacto extends MaestroModel {

    public static RECORD_NAME = 'contactos';
    public static CODIGO_REGISTRO = 'contacto';
    public static CODIGO_MODULO = 'notificacion';
    public static NOMBRE_SINGULAR = 'Contacto';
    public static NOMBRE_PLURAL = 'Contactos';

    private _idEmpresa:             number;
    private _nombreEmpresa:         string;
    private _celular:               string;
    private _correo:                string;
    private _documento:             string;


    constructor() {
        super();
        this._idEmpresa = this.seguridad.getCurrentUser()?.id_empresa;
        this._nombreEmpresa = this.seguridad.getCurrentUser()?.nombre_empresa;
    }

    public set idEmpresa( idEmpresa: number ) {
        this._idEmpresa = idEmpresa;
    }
    public get idEmpresa(): number {
        return this._idEmpresa;
    }

    public set nombreEmpresa( nombreEmpresa: string ) {
        this._nombreEmpresa = nombreEmpresa;
    }
    public get nombreEmpresa(): string {
        return this._nombreEmpresa;
    }

    public set celular( celular: string ) {
        this._celular = celular;
    }
    public get celular(): string {
        return this._celular;
    }

    public set correo( correo: string ) {
        this._correo = correo;
    }
    public get correo(): string {
        return this._correo;
    }
    public set documento( documento: string ) {
        this._documento = documento;
    }
    public get documento(): string {
        return this._documento;
    }


    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'documento', label: 'Documento', type: 'text' },
            { field: 'nombre', label: 'Nombre', type: 'text' },
            { field: 'celular', label: 'Celular', type: 'text' },
            { field: 'correo', label: 'Correo', type: 'text' },
        ]
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.nombre_empresa;
        this._correo = objeto.correo;
        this._celular = objeto.celular;
        this._documento = objeto.documento;
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa, Validators.required));
        fg.addControl("correo", new FormControl(this._correo));
        fg.addControl("celular", new FormControl(this._celular));
        fg.addControl("documento", new FormControl(this._documento, Validators.required));
        return fg;
    }

    async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.nombre_empresa;
        this._celular = objeto.celular;
        this._correo = objeto.correo;
        this._documento = objeto.documento;
    }

    async guardar( service: ContactoService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    async actualizar( service: ContactoService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    async eliminar( service: ContactoService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}